<template>
    <div id="signature_dialog">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header" style="padding: 4px; background-color: #6455e1; ">
                    <h5 class="modal-title" style="text-align:center; margin:auto;">Sign Your Contract Electronically Here</h5>
                    <button type="button" class="btn btn-icon" data-action="cancel" @click="onPadCancel">
                        <svg class="bi bi-x" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
                            <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
                        </svg>
                    </button>
                </div>
                <div class="modal-body" style="padding:4px !important;">
                    <div class="signature-terms">
                        <iframe v-show="isLoadTerms" ref="signature-terms" frameborder="0" scrolling="yes" ></iframe>
                        <div v-if="!isLoadTerms" style="text-align: center; padding-top: 20px;">Loading Your Contract...</div>
                    </div>
                    <div id="signature-pad" class="signature-pad">
                        <div class="signature-pad--toolbar">
                            <div class="signature-pad--actions">
                                <div>
                                </div>
                            </div>
                        </div>
                        <div class="signature-pad--body">
                            <canvas id="signature-pad--canvas"></canvas>
                        </div>
                        <div class="signature-pad--line"></div>
                        <div class="signature-pad--mark unselectable-text" style="color:black;">Sign here with your finger, trackpad, or mouse.</div>
                        <div class="signature-pad--footer">
                            <div class="signature-pad--actions">
                                <div>
                                    <button type="button" class="btn btn-danger btn-sm" data-action="clear" @click="onPadClear">
                                        <svg class="bi bi-trash-fill" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z" />
                                        </svg>Clear
                                    </button>
                                 
                                    <button type="button" class="btn btn-success btn-sm" data-action="agree" @click="onPadAgree">
                                        <svg class="bi bi-check2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                                        </svg>
                                        Agree
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SignaturePad from 'signature_pad'

    export default {
        data() {
            return {
                canvas: null,
                signaturePad: null,
                isLoadTerms: false
            }
        },
        mounted() {
            this.signature_init();
        },
        props: {
            terms: {
                type: String,
                default: ''
            }
        },
        watch: {
            terms: function (newVal) {
                this.$refs['signature-terms'].contentDocument.write(newVal);
                this.isLoadTerms = true;
            }
        },
        methods: {
            signature_init() {
                //console.log("======> signature_init");
                if (null === this.signaturePad) {
                    this.canvas = document.getElementById("signature-pad--canvas");
                    this.signaturePad = new SignaturePad(this.canvas, {
                        backgroundColor: 'rgba(255, 255, 255, 0.0)',
                        penColor: 'rgb(0, 0, 0)',
                        minWidth: 0.01,
                        maxWidth: 2.5,
                        dotSize: 2
                    });
                }

                /*
                this.signaturePad.onClear = () => {
                    console.log("========== Signature Pad On Clear =========");
                }

                this.signaturePad.onCancel = () => {
                    console.log("========== Signature Pad On Cancel =========");
                }

                this.signaturePad.onAgree = (PNGData, info) => {
                    console.log(`========== Signature Pad On Agree =========`, info);
                    console.log(`========== PNG Data =========`, PNGData);
                }
                */

                window.onresize = this.resizeCanvas;
                this.resizeCanvas();
            },

            resizeCanvas() {
                // console.log("========> Resize Canvers");
                var ratio = Math.max(window.devicePixelRatio || 1, 1);
                this.canvas.width = this.canvas.offsetWidth * ratio;
                this.canvas.height = this.canvas.offsetHeight * ratio;
                this.canvas.getContext("2d").scale(ratio, ratio);
                this.signaturePad.clear();
            },

            download(dataURL, filename) {
                //console.log("Download Data ===>", dataURL);
                if (navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") === -1) {
                    window.open(dataURL);
                } else {
                    var blob = this.dataURLToBlob(dataURL);
                    var url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    a.style = "display: none";
                    a.href = url;
                    a.download = filename;

                    document.body.appendChild(a);
                    a.click();

                    window.URL.revokeObjectURL(url);
                }
            },

            dataURLToBlob(dataURL) {
                var parts = dataURL.split(';base64,');
                var contentType = parts[0].split(":")[1];
                var raw = window.atob(parts[1]);
                var rawLength = raw.length;
                var uInt8Array = new Uint8Array(rawLength);
                for (var i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], { type: contentType });
            },

            dataURLToFileObject(dataURL) {
                var parts = dataURL.split(';base64,');
                var contentType = parts[0].split(":")[1];
                var raw = window.atob(parts[1]);
                var rawLength = raw.length;
                //console.log(`==== Signature Pad Raw Image Size: ${rawLength} ====`);
                var uInt8Array = new Uint8Array(rawLength);
                for (var i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                //console.log(`==== Signature Pad Buff Image Size: ${uInt8Array.length} ====`);
                var b = new Blob([uInt8Array], { type: contentType });
                var file = new File([b], "signature.png", { type: contentType, lastModified: new Date().getTime() });
                return file;
            },

            renderTestLink() {
                var imageFile = this.dataURLToFileObject(this.signaturePad.toDataURL());
                var fr = new FileReader();
                fr.onload = () => {
                    document.body.innerHTML += `
                           <a href="${URL.createObjectURL(imageFile)}" download="${imageFile.name}">download</a>
                            <p>file type: ${imageFile.type}</p>
                            <p>file last modified: ${new Date(imageFile.lastModified)}</p>
                          `;
                }
                fr.readAsArrayBuffer(imageFile);
            },

            onPadSetColor(v) {
                this.signaturePad.penColor = v;
                this.signaturePad.clear();
            },

            onPadClear() {
                this.signaturePad.clear();
                if (this.signaturePad.onClear) {
                    this.signaturePad.onClear();
                }
            },

            onPadCancel() {
                if (this.signaturePad.onCancel) {
                    this.signaturePad.onCancel();
                }

                this.$emit('cancel-event');
            },

            onPadAgree() {
                if (this.signaturePad.isEmpty()) {
                    //this.$alert("Please provide a signature first.");
                    this.$emit('agree-event', null);
                } else {
                    //SVG
                    //var dataURL = signaturePad.toDataURL('image/svg+xml');

                    //PNG
                    var dataURL = this.signaturePad.toDataURL();
                    if (this.signaturePad.onAgree) {
                        //var r = Number.parseFloat((this.canvas.width / this.canvas.height).toFixed(3));
                        //this.signaturePad.onAgree(dataURL, { width: this.canvas.width, height: this.canvas.height, rate: r });
                    }
                    this.$emit('agree-event', this.dataURLToFileObject(dataURL));
                }
            }

        }
    }
</script>

<style scoped>

    .btn-sm {
        width: 100px;
        height: fit-content;
        font-size: 14px;
        line-height: 36px;
    }

    .unselectable-text {
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera, and Edge */
    }

    #signature_dialog {
        display: table-cell;
        vertical-align: middle;
    }

        #signature_dialog .modal-title {
            color: #fff;
        }

        #signature_dialog .modal-content {
            box-shadow: 0px 0px 30px rgba(0,0,0,0.7);
            background-color: rgba(35,139,140,0.3);
        }

        #signature_dialog .modal-body {
            background-color: rgb(240,240,240);
            height:80vh;
        }


    .signature-pad *::before,
    .signature-pad *::after {
        box-sizing: border-box;
    }

    .signature-pad {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        font-size: 10px;
        width: 100%;
        max-width: 700px;
        height: 260px;
        background-color: #fff;
        border-radius: 0px 0px 6px 6px;
        border: 1px solid #c0c0c0;
        padding: 0px;
        color: #303030;
        margin: auto;
        overflow: hidden;
    }

    .signature-terms {
        width:100%;
        padding:0px;
        margin:0px;
        height:calc(100% - 260px);
    }

        .signature-terms > iframe {
            height: 100%;
            padding: 0px 0px 8px 0px;
            margin:0px;
            width: 100%;
            background-color: rgb(255, 255, 255);
        }

        .signature-pad--body {
            position: relative;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            border: none;
            background-color: #ffffff;
        }

        .signature-pad--body
        canvas {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: transparent;
            border: 1px solid #e0e0e0;
            margin: 0px;
            z-index: 1;
        }


    .signature-pad--line {
        position: absolute;
        left: 10%;
        bottom: 40%;
        width: 80%;
        background-color: transparent;
        height: 2px;
        border-bottom: 1px dashed #a0a0a0;
        z-index: 0;
    }

    .signature-pad--mark {
        position: absolute;
        left: auto;
        bottom: 30%;
        width: 100%;
        color: #c0c0c0;
        font-size: 14px;
        font-weight: lighter;
        background-color: transparent;
        z-index: 0;
        text-align: center;
    }

    .signature-pad--toolbar {
        color: #606060;
        text-align: center;
        font-size: 1.5em;
        font-weight: normal;
        margin: 0px;
        padding: 0px 12px 8px 12px;
        background-color: #efefef;
    }

    .signature-pad--footer {
        color: #606060;
        text-align: center;
        font-size: 1.5em;
        font-weight: normal;
        margin: 0px;
        padding: 8px;
        background-color: #efefef;
    }

    .signature-pad--actions {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        margin-top: 8px;
    }


    .signature-pad--footer .signature-pad--actions {
        display: block;
        text-align: center;
    }

        .signature-pad--footer .signature-pad--actions button {
            margin: 0 8px !important;
        }

    .signature-pad--actions .pen {
        width: 24px;
        height: 24px;
        display: inline-block;
        margin: 0px;
        padding: 0px;
    }

    .signature-pad--actions button svg {
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
    }

    clean {
    }

    @media (max-width: 940px) {
    }

    @media (min-width:576px) {
        .modal-dialog {
            max-width: 80%;
            margin: 1.75rem auto
        }
    }
</style>